<template>
	<div class="news-con">
		<mobile-header :active-route="activeRoute" @active-up="beforeRoute"></mobile-header>
		<mobile-main
		ref="activeMain"
		:active-route="activeRoute"
		:mainConStyle="mainConStyle"
		:bannerImage="bannerImage"></mobile-main>
		<mobile-footer :linkVisible="linkVisible" :applyFooterStyle="applyFooterStyle"></mobile-footer>
	</div>
</template>
<script>
    import newsImage1 from '@/assets/mobile/resource/images/news/banner_news_01.png'
    export default{
        components: {
            MobileHeader: () => import('@/components/mobile/zh-cn/header'),
            MobileFooter: () => import('@/components/mobile/zh-cn/footer'),
            MobileMain: () => import('@/components/mobile/zh-cn/main'),
        },
        data(){
            return {
                linkVisible: false,
                mainConStyle: {},
                applyFooterStyle: {
                    minHeight: '9.5rem',
                    background: '#363940'
				},
                bannerImage: '',
                activeRoute: {},
            };
        },
        methods: {
            beforeRoute(currentActiveRoute){
                const _this = this;
                var activeRoute = [];
                const activeRouteParams = _this.$route.params;
                if ($.type(currentActiveRoute) === 'undefined') {
                    if ($.isEmptyObject(activeRouteParams) === false) {
                        activeRoute = activeRouteParams;
                    } else {
                        activeRoute = {
                            activeLevel1: 3,
                            activeLevel2: 1
                        };
                    }
                } else {
                    activeRoute = currentActiveRoute;
                }

                _this.activeRoute = activeRoute;
                _this.updateBannerAndMainHeight(activeRoute);
            },
            // 更新Banner 和 页面高度
            updateBannerAndMainHeight(activeRoute){
                const _this = this;
				/*console.log("#3[solution][activeRoute]", activeRoute)*/
                var activeRouteBak = activeRoute;
                if ($.isEmptyObject(activeRoute) === false) {
                    switch (activeRoute.activeLevel2) {
                        case 1:
                            _this.bannerImage = newsImage1;
                            break;
                        default:
                            _this.bannerImage = newsImage1;
                            break;
                    }
                    if (activeRouteBak.hasOwnProperty('activeLevel3') === false) {
                        activeRouteBak['activeLevel3'] = 0;
                    }
                    var activeRouteBakToString = [activeRouteBak.activeLevel2, activeRouteBak.activeLevel3];
                    switch (activeRouteBakToString.join(',')) {
                        case '1,0':
                            _this.mainConStyle = {'min-height': '233.0rem'};
                            break;
                        default:
                            _this.mainConStyle = {'min-height': '233.0rem'};
                            break;
                    }
                }

				/*console.log("#1[news][updateBannerAndMainHeight,activeRouteBakToString]", activeRoute,
				 activeRouteBakToString.join(','))*/
            }
        },
        watch: {
            $route: {
                handler: 'beforeRoute',
                deep: true
            }
        },
        created(){
            const _this = this;
            _this.beforeRoute();
        },
        mounted(){
            const _this = this;
            _this.$nextTick(() => {
                document.body.style.overflow = 'auto';
            });
        }
    }
</script>

<style scoped="">

</style>


// WEBPACK FOOTER //
// src/components/mobile/zh-cn/news.vue